export const error = {
  required: '必須です',
  below7: '7文字以内で入力してください',
  below20: '20文字以内で入力してください',
  below250: '250文字以内で入力してください',
  below2000: '2000文字以内で入力してください',
  number: '数字を入力してください',
  email: 'メールアドレス形式で入力してください',
  invalidFileType: 'PDF、PNG、JPG、JPEGのファイルを選択してください',
  maxFiles: '一度にアップロードできるファイルは最大30ファイルです',
  maxSize: 'ファイルサイズの上限は7MBです',
  min: '6文字以上を入力してください',
  mixed: 'パスワードは英字と数字を必ず含め、記号も使用可能です。',
  image: '対応していない画像形式です',
  imageSize: '画像は10MBまでしか登録できません',
  passwordMatch: 'パスワードが一致しません',
  date: '日付形式で入力してください',
  csvMaxSize: 'ファイルサイズの上限は20MBです',
  invalidCsvType: 'CSV形式のファイルを選択してください',
  demoMaxFiles: '一度にアップロードできるファイルは最大100ファイルです',
  invalidEncoding: 'UTF-8 のファイルを選択してください。',
};
